import './styles.scss';

import reportTypes, { hiddenReportTypes } from '@/pages/Reports/DynamicReport/reportTypes';

import { Container } from 'react-bootstrap';
import DynamicReport from '@/pages/Reports/DynamicReport';
import ProtectedRoute from '@/components/ProtectedRoute';
import PunchPolicyUpload from '@/pages/PunchPolicy/components/PunchPolicyUpload/PunchPolicyUpload';
import { getClasses } from '@/utils';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useSwitch from '@/hooks/useSwitch';

const reportOptions = Object.entries(reportTypes).reduce((acc, [key, value]) => {
  const [title, component] = value;
  acc[key] = [title, component];
  return acc;
}, {});

const Reports = (): JSX.Element => {
  const { type } = useParams();
  const allReportTypes = { ...reportTypes, ...hiddenReportTypes };
  const reportType = Object.keys(allReportTypes).includes(type) ? type : Object.keys(allReportTypes)[0];

  const EmptyElement = useMemo(() => {
    switch (reportType) {
      case 'punchReport':
        return PunchPolicyUpload;
      default:
        return undefined;
    }
  }, [reportType]);

  const [title, Content = DynamicReport] = useSwitch(reportType, reportOptions, reportTypes?.[Object.keys(reportTypes)?.[0]] || null);

  const isReport = type?.toLowerCase?.()?.endsWith?.('report');
  const isDashboard = type?.toLowerCase?.()?.endsWith?.('dashboard');
  const isFullWidth = !type || isReport || isDashboard;

  const classes = getClasses('page-container', type, 'w-100', isFullWidth ? 'full-width bg-white' : undefined);

  return (
    <ProtectedRoute title={title} key={title}>
      <Container className={classes} fluid>
        <Content onEmpty={EmptyElement} />
      </Container>
    </ProtectedRoute>
  );
};

export default Reports;
